import React from 'react'

const index = () => {
    window.location.href = 'https://discord.gg/bridgeonline';
  return (
    <div></div>
  )
}

export default index